import { useState } from 'react';
import { ArrowUpRight, Layers, TrendingUp, Users } from 'lucide-react';
import { BUSINESS, IMAGES } from '../../mock';
import LoginModal from '../LoginModal';

const ICONS = [Layers, TrendingUp, Users];

export default function Business() {
  const [loginOpen, setLoginOpen] = useState(false);

  return (
    <section id="business" className="relative py-20 lg:py-32 bg-[#0B3B2E] text-[#F5F1E8] overflow-hidden">
      <div className="absolute -top-24 -left-24 w-[500px] h-[500px] rounded-full bg-[#C8944B]/12 blur-3xl" />
      <div className="absolute -bottom-24 -right-24 w-[500px] h-[500px] rounded-full bg-[#F5F1E8]/5 blur-3xl" />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-8">
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#C8944B] font-medium reveal">
              {BUSINESS.eyebrow}
            </p>
            <h2 className="mt-4 font-serif text-[40px] lg:text-[56px] leading-[1.05] reveal">
              {BUSINESS.title}
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-[16px] leading-relaxed text-[#F5F1E8]/75 reveal">
              {BUSINESS.body}
            </p>
          </div>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-4">
          {BUSINESS.cards.map((c, i) => {
            const Icon = ICONS[i];
            return (
              <button
                key={c.title}
                type="button"
                onClick={() => setLoginOpen(true)}
                data-testid={`business-card-${c.title.toLowerCase().replace(/\s+/g, '-')}`}
                className="group reveal relative text-left p-7 rounded-2xl bg-[#F5F1E8]/6 border border-[#F5F1E8]/12 hover:bg-[#F5F1E8]/10 hover:-translate-y-1 transition-all duration-500 overflow-hidden"
              >
                <div className="w-12 h-12 rounded-full bg-[#C8944B] text-[#0B3B2E] flex items-center justify-center mb-6">
                  <Icon className="w-5 h-5" strokeWidth={2.2} />
                </div>
                <h3 className="font-serif text-[26px] leading-tight">{c.title}</h3>
                <p className="mt-3 text-[14px] leading-relaxed text-[#F5F1E8]/70">{c.description}</p>
                <span className="mt-6 inline-flex items-center gap-1 text-[13px] font-medium text-[#C8944B]">
                  {c.link}
                  <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </button>
            );
          })}
        </div>

        {/* Featured case study */}
        <div className="mt-16 grid lg:grid-cols-12 gap-8 items-center p-4 lg:p-6 rounded-3xl bg-[#F5F1E8]/6 border border-[#F5F1E8]/12">
          <div className="lg:col-span-5 relative aspect-[4/3] rounded-2xl overflow-hidden">
            <img src={IMAGES.business} alt="Finance team at work" className="w-full h-full object-cover" />
          </div>
          <div className="lg:col-span-7 px-2 lg:px-4">
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#C8944B]">Case study</p>
            <h3 className="mt-3 font-serif text-[28px] lg:text-[34px] leading-tight">
              &ldquo;Vector Forward locked in an EUR rate on a £8M supplier contract. Our margin stopped moving overnight.&rdquo;
            </h3>
            <p className="mt-4 text-[14px] text-[#F5F1E8]/70">
              Priya Ramaswamy · Head of Finance, Loopyard
            </p>
            <button
              type="button"
              onClick={() => setLoginOpen(true)}
              data-testid="business-case-study-cta"
              className="mt-6 inline-flex items-center gap-1.5 px-5 h-11 rounded-full bg-[#C8944B] text-[#0B3B2E] font-medium text-[14px] hover:bg-[#D9A85C] transition-colors"
            >
              Read the case study <ArrowUpRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>

      <LoginModal open={loginOpen} onOpenChange={setLoginOpen} defaultTab="signup" />
    </section>
  );
}
